import { Link } from 'react-router-dom';
import { ArrowRight } from '@phosphor-icons/react';
import { Reveal } from '@/components/motion';
import { SERVICES, IMAGES } from '@/data/site';
import IconResolver from '@/components/IconResolver';

const ICON_MAP = {
  'ndis-transport': 'Wheelchair',
  'community-transport': 'UsersThree',
  'aged-care-transport': 'HandHeart',
  'hospital-discharge': 'FirstAid',
  'wheelchair-accessible': 'WheelchairMotion',
  'medical-appointment': 'Stethoscope',
  'school-education': 'GraduationCap',
  'group-transport': 'Van',
  'social-community-access': 'Smiley',
  'tac-worksafe': 'ShieldCheck',
};

export default function ServicesIndex() {
  return (
    <>
      <section className="pt-16 md:pt-24 pb-14" data-testid="services-hero">
        <div className="container-x">
          <div className="max-w-4xl">
            <Reveal>
              <div className="overline mb-6">Our services</div>
              <h1 className="h-display text-balance">
                Ten transport services. One national standard.
              </h1>
              <p className="body-lg mt-8 max-w-2xl text-pretty">
                Every service is delivered by trained drivers, insured vehicles and a coordination team on
                standby 24/7 — under one integrated operating model.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="pb-24" data-testid="services-grid">
        <div className="container-x grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={i * 0.04}>
              <Link
                to={`/services/${s.slug}`}
                data-testid={`services-index-card-${s.slug}`}
                className="group block h-full rounded-3xl bg-neutral-50 border border-neutral-200 overflow-hidden hover:border-brand hover:bg-white hover:shadow-[0_20px_60px_rgba(17,24,39,0.08)] hover:-translate-y-1 transition-all duration-500"
              >
                <div className="aspect-[16/10] bg-neutral-100 overflow-hidden">
                  <img
                    src={IMAGES[s.image] || IMAGES.hero}
                    alt={s.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="p-6 md:p-7">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-xl bg-brand/10 flex items-center justify-center">
                      <IconResolver name={ICON_MAP[s.slug]} size={20} className="text-brand" />
                    </div>
                    <span className="text-xs uppercase tracking-widest font-bold text-brand">{s.slug.split('-')[0]}</span>
                  </div>
                  <h3 className="font-display font-bold text-xl md:text-2xl text-ink">{s.name}</h3>
                  <p className="body-md mt-2 line-clamp-2">{s.tagline}</p>
                  <div className="mt-5 inline-flex items-center gap-2 text-brand font-semibold text-sm">
                    Explore service <ArrowRight size={14} weight="bold" />
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
